import { createAsyncThunk } from '@reduxjs/toolkit'
import { userAccountInfo } from 'helpers/user'
import { setProductType } from 'helpers/analytics'
import resetPasswordAPI from 'services/resetPassword'
import {
  EligibilityCheckRequest,
  PostLoginUpdatePasswordRequest
} from 'typings/resetPassword'
import { hasAccountNotSupported } from 'helpers/brandHelpers'

const SLICE_NAME = 'resetPasswordSlice'

/**
 * This thunk handles the reset password flow for Transmit MFA
 */
export const getResetPasswordEligibilityCheck = createAsyncThunk(
  `${SLICE_NAME}/getEligibilityCheck`,
  async (payload: EligibilityCheckRequest, { rejectWithValue }) => {
    try {
      const response = await resetPasswordAPI.getEligibilityCheck(payload)

      const {
        accountIdType,
        accountType,
        'cipher.accountId': accountID,
        cardType
      } = response

      userAccountInfo.accountType = accountType
      userAccountInfo.accountIdType = accountIdType || ''
      userAccountInfo.accountID = accountID
      userAccountInfo.cardType = cardType
      setProductType(accountType)

      userAccountInfo.accountDetail = {
        'cipher.accountId': accountID,
        'cipher.partialAccountId': '',
        switchAccountType: 'SELF'
      }

      /*
       * Reject if account is Sams prox
       * Remove it once the feature flag for sams prox is removed
       */
      if (hasAccountNotSupported(accountType)) {
        return rejectWithValue({
          response: { businessErrors: [{ code: 'invalid.sams.account.type' }] }
        })
      }
      return response
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

export interface ResetPasswordPayload {
  /** sessionId from reset password eligibility check */
  sessionId: string
  /** new password set by the user */
  newPassword: string
  /** access token received from the v3 oauth token endpoint */
  accessToken: string
}

export const resetPassword = createAsyncThunk(
  'resetPasswordSlice/updatePassword',
  async (payload: ResetPasswordPayload, { rejectWithValue }) => {
    try {
      return await resetPasswordAPI.getUpdatePassword(payload)
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

export const updatePasswordPostLogin = createAsyncThunk(
  `${SLICE_NAME}/updatePasswordPostLogin`,
  async (payload: PostLoginUpdatePasswordRequest, { rejectWithValue }) => {
    try {
      return await resetPasswordAPI.getPostLoginUpdatePassword(payload)
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)
